export const OLYMPICS_SHELF_TITLE = 'Olimpíada Árvore'
export const OLYMPICS_SHELF_SUBTITLE = 'As Marcas de um Leitor'
